import React from 'react';

import * as Styled from 'dashboard/styles/Recharts.style';

interface TooltipPayloadItem {
  name: string;
  value: number;
  dataKey: string | number;
  payload: {
    risk: string;
    note_count: number;
  };
}

interface CustomTooltipProps {
  active?: boolean;
  payload?: TooltipPayloadItem[];
  occurrencesLabel: (count: number) => string;
  isVisible?: boolean;
}

export default function CustomTooltip({
  active,
  payload,
  occurrencesLabel,
  isVisible = true,
}: CustomTooltipProps) {
  if (!active || !payload?.length || !isVisible) return null;

  const item = payload[0];

  return (
    <Styled.Tooltip>
      <Styled.TooltipSection>
        <Styled.TooltipTitle>{item.payload.risk}</Styled.TooltipTitle>
        <Styled.TooltipSubtitle style={{ marginBottom: 0 }}>
          {occurrencesLabel(item.payload.note_count)}
        </Styled.TooltipSubtitle>
      </Styled.TooltipSection>
    </Styled.Tooltip>
  );
}
